/**
 * Generate a consistent color for a given string
 * Returns a hex color code based on the hash of the input string
 */
export const stringToColor = (str: string): string => {
  // Use a better hash function for more distribution
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
    hash = hash & hash; // Convert to 32bit integer
  }

  // Use different parts of the hash for different color components
  // This ensures better color distribution
  const hash2 = Math.abs(hash * 2654435761); // Golden ratio prime
  const hash3 = Math.abs(hash * 16807); // Another good prime

  // Generate HSL color with good saturation and moderate lightness for readability
  // Avoid bright colors by keeping lightness moderate (40-55%)
  const hue = Math.abs(hash) % 360;
  const saturation = 65 + (Math.abs(hash2) % 20); // 65-85%
  const lightness = 40 + (Math.abs(hash3) % 16); // 40-55% (moderate, not too dark or bright)

  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
};

/**
 * Determine if a color is light or dark (for text contrast)
 */
export const isLightColor = (hslColor: string): boolean => {
  const match = hslColor.match(/hsl\(\d+,\s*\d+%,\s*(\d+)%\)/);
  if (!match) return false;
  const lightness = parseInt(match[1], 10);
  return lightness > 60;
};
